import React from 'react';
import Announcements from '../../components/announcements/announcements';

const AnnouncementPage = () => {
  return <Announcements />;
};

export default AnnouncementPage;
